import theme from '@vromo/ui/components/theme';

export default {
    pageTitle: {
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        color: theme.darkText
    },
    subTitle: {
        paddingTop: 4,
        paddingBottom: 12,
        textAlign: 'center',
        color: theme.darkText
    }
};
